export default "__VITE_ASSET__c8f15b4f__"